/**
 * Siapa boleh mengubah bagian mana dari akun login karyawan — CERMIN layar dari
 * `backend/pagar_akun.py` (keputusan owner 18 Sep 2026: role admin/superadmin,
 * ganti role, dan reset password akun istimewa hanya oleh Bos; keputusan owner
 * 20 Sep 2026 §17 opsi a: akun role EMPLOYEE yang memegang KUASA — mengelola
 * karyawan/akun, izin, keuangan, atau persetujuan — diperlakukan sama).
 *
 * Backend tetap penentunya; berkas ini ada supaya layar tidak menampilkan kontrol
 * yang ujungnya 403 (aturan #3 CLAUDE.md). Status "berkuasa" TIDAK dihitung ulang
 * di sini (CLAUDE.md instruksi tugas ini): backend `pagar_akun.akun_berkuasa()`
 * menilainya dari izin EFEKTIF (lewat `deps.authorize_module`, jadi izin
 * berjangka & bawaan role ikut terhitung) dan mengirimkannya sebagai
 * `login_akun_berkuasa` di baris `GET /employees` (akun tertaut terpilih —
 * pemilih yang sama dengan yang dipakai `PATCH /employees`). Kalau dihitung
 * ulang di sini dari nama role/template saja, layar dan backend bisa berpisah
 * jalan persis seperti celah `TEMPLATE_KHUSUS_BOS` lama yang ditutup batch ini.
 *
 *   - "akun istimewa" = akun yang SUDAH ADA dengan role selain persis "employee"
 *     (role kosong/tak dikenal juga istimewa — konservatif, sama dengan backend)
 *     ATAU akun role employee yang `login_akun_berkuasa` (dari server);
 *   - "akun sendiri" = baris karyawan milik pengguna yang sedang login.
 *
 * `form` adalah baris GET /employees (membawa has_login_account, login_role,
 * dan login_akun_berkuasa).
 */
export function aksesAkun({ form, aktor, isEdit }) {
  const isBos = aktor?.role === "superadmin";
  const punyaAkun = !!(isEdit && form?.has_login_account);
  const akunSendiri = !!(punyaAkun && aktor?.employee_id && aktor.employee_id === form?.id);
  const akunIstimewa = !!(punyaAkun && ((form?.login_role || "") !== "employee"
    || form?.login_akun_berkuasa));
  return {
    isBos,
    akunSendiri,
    akunIstimewa,
    bolehUbahRole: isBos,
    bolehUbahTemplate: isBos || (!akunIstimewa && !akunSendiri),
    bolehResetPassword: isBos || (!akunIstimewa && !akunSendiri),
    bolehUbahEmail: isBos || !akunIstimewa,
  };
}

// Isian form Tambah/Edit Karyawan yang BUKAN data karyawan. Tidak pernah ikut
// terkirim apa adanya di PATCH /employees — medan akun disusun terpisah di bawah.
const MEDAN_FORM_NON_KARYAWAN = new Set([
  "id", "created_at", "create_login_account", "login_password",
  "enable_login_account", "login_password_reset", "login_role", "login_template_key",
]);

/**
 * Body PATCH /employees/{id} dari form Edit Karyawan (`Employees.jsx::save()`).
 *
 * `awal` = baris GET /employees saat modal DIBUKA. Role & template akun hanya
 * dikirim kalau pengguna BOLEH mengubahnya DAN nilainya memang berbeda dari
 * `awal`. Dulu keduanya dikirim ulang pada setiap simpan, sehingga:
 *   - daftar basi (Bos baru saja mengganti role akun itu) membuat HR yang cuma
 *     mengganti no HP ditolak 403 "role hanya bisa diganti Bos" — karena backend
 *     membaca kiriman lama itu sebagai permintaan mengembalikan role;
 *   - template yang baru diganti Bos diam-diam dikembalikan ke nilai lama oleh
 *     simpan HR berikutnya (kehilangan pembaruan, tanpa pesan apa pun).
 * Yang tidak dikirim tidak diubah backend, jadi "tidak menyentuh akun" kini
 * benar-benar tidak menyentuh akun.
 */
export function bodyEditKaryawan({ form, awal, aktor }) {
  const f = form || {};
  const a = awal || {};
  const body = {};
  for (const [k, v] of Object.entries(f)) {
    if (!MEDAN_FORM_NON_KARYAWAN.has(k)) body[k] = v;
  }
  if (f.enable_login_account) body.enable_login_account = true;
  if (f.login_password_reset) body.login_password_reset = f.login_password_reset;
  const akses = aksesAkun({ form: a, aktor, isEdit: true });
  const roleBaru = f.login_role || "";
  if (akses.bolehUbahRole && roleBaru && roleBaru !== (a.login_role || "")) {
    body.login_role = roleBaru;
  }
  const templateBaru = f.login_template_key || "";
  if (akses.bolehUbahTemplate && templateBaru !== (a.login_template_key || "")) {
    body.login_template_key = templateBaru || null;
  }
  return body;
}
